import Vue from "vue";

interface Notification {
  id: number;
  message: string;
  status: "danger" | "success" | "warning";
}

const state = Vue.observable({
  notifications: [] as Notification[],
  nextId: 1
});

export const NotificationService = {
  get notifications(): Notification[] {
    return state.notifications;
  },

  show(
    message: string,
    status: "danger" | "success" | "warning" = "danger",
    duration = 5000
  ): void {
    const id = state.nextId++;
    state.notifications.push({ id, message, status });
    setTimeout(() => {
      this.remove(id);
    }, duration);
  },

  remove(id: number): void {
    state.notifications = state.notifications.filter(n => n.id !== id);
  }
};
